var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedAccounts = function SvgLinkedAccounts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10808_178973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4887 10.5114C15.0963 12.119 15.1403 14.6815 13.1179 16.7039L10.3787 19.4431C8.35622 21.4656 5.79379 21.4215 4.18619 19.8139C2.5786 18.2063 2.53455 15.6439 4.55702 13.6214L5.52931 12.6409",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5114 13.4886C8.90378 11.881 8.85977 9.31862 10.8822 7.29615L13.6214 4.55703C15.6439 2.53452 18.2063 2.57857 19.8139 4.18617C21.4215 5.7938 21.4655 8.35619 19.4431 10.3787L18.4708 11.3591",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.231,
    cy: 18.5,
    r: 2.5,
    stroke: "currentColor",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10808_178973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.46,
    height: 21.46,
    fill: "currentColor",
    transform: "translate(1.27002 1.27002)"
  })))));
};
export default SvgLinkedAccounts;